


export enum ADJ_STATUS {
	PLAY,
	STOP,
}

export enum ADJ_PROPS {

	//#region HEADER
	/** [R] MODE: 0 - OFF / 1 - MANUALE / 2 - AUTO */
	MODE = "ADJ_MODE",
	// [W] MODE
	MODE_RQY = "ADJ_MODE_RQY",
	// [R] STATUS stato dell'ADJUSTMENT
	STATUS = "ADJ_STATUS",
	// [RW][seconds][dec] ogni quanto devo effettuare la fase ADJ 
	TIMER_ADJ_COUNTDOWN = "ADJ_Tim_Interval",
	// [R?][seconds] il tempo da resettare al timer "ADJ_Tim_Interval"
	TIMER_ADJ_COUNTDOWN_PRESET = "ADJ_Tim_Interval_P",
	// [RW][seconds][dec] quanto tempo deve durare la fase ADJ
	TIMER_ADJ_TIMEOUT = "ADJ_Tim_Countdown",
	// [R?][seconds] il tempo da resettare al timer "ADJ_Tim_Countdown"
	TIMER_ADJ_TIMEOUT_PRESET = "ADJ_Tim_Max_Auto_ADJ_P",


	//#endregion

	//#region PH
	/** [RW][real] valore PH desiderato*/
	PH_SETPOINT = "PH_SetPoint",
	/** [R][real] valore PH misurato */
	PH_MESURED = "ADJ_PH_MIS",
	/** [R][real] differenza tra PH misurato e desiderato */
	PH_DELTA = "ADJ_PH_DELTA",
	/** [R][bool][false=0] determina il tipo di controllo da fare */
	PH_CTRL_0_ENABLED = "ADJ_CTRL000_Enabled",
	/** [R][bool][false=0] determina il tipo di controllo da fare */
	PH_CTRL_1_ENABLED = "ADJ_CTRL001_Enabled",
	//#endregion

	//#region EC
	/** [RW][real] valore PH desiderato*/
	EC_SETPOINT = "EC_SetPoint",
	/** [R][real] valore PH misurato */
	EC_MESURED = "ADJ_EC_MIS",
	/** [R][real] differenza tra PH misurato e desiderato */
	EC_DELTA = "ADJ_EC_DELTA",
	/** [R][bool][false=0] determina il tipo di controllo da fare */
	EC_CTRL_2_ENABLED = "ADJ_CTRL002_Enabled",
	/** [R][bool][false=0] determina il tipo di controllo da fare */
	EC_CTRL_3_ENABLED = "ADJ_CTRL003_Enabled",
	//#endregion

	//#region  COMMAND
	/** [RW][bool] comando per far partire subito PH */
	PH_CMM_START = "ADJ_fAdj_PH_RQY",
	/** [RW][bool] comando per far partire subito EC */
	EC_CMM_START = "ADJ_fAdj_EC_RQY",
	/** [RW][bool] comando per fermare tutto */
	CMM_STOP = "ADJ_fAdj_STOP_RQY",
	//#endregion

}

// https://app.clickup.com/30373227/v/dc/wyxbb-22155/wyxbb-32015?block=block-81d0a78a-09fa-461f-932f-bc706feff6a4
export enum ADJ_ADV_ELEM {
	PH_UP = "ADJ_CTRL000",
	PH_DOWN = "ADJ_CTRL001",
	EC_UP = "ADJ_CTRL002",
	EC_DOWN = "ADJ_CTRL003",
}
export enum ADJ_ADV_PROP {
	/** soglia zero di intervento */
	THRESHOLD_0 = "_S0",
	/** prima soglia di intervento */
	THRESHOLD_1 = "_S1",
	/** Seconda soglia di intervento */
	THRESHOLD_2 = "_S2",
	/* Errore rilevato tra reale e setpoint */
	ERROR = "_Error",
	/** Timer di correzione */
	CORRECTION_TIMER = "_T",
	/** Intervallo di intervento correzione */
	CORRECTION_INTERVAL = "_T_0",
	/** Tempo minimo di correzione */
	CORRECTION_MIN_PULSE = "_T_min",
	/** Percentuale del tempo di correzione sul totale */
	CORRECTION_PERC_USE = "_Y",
	/** Correzione in corso o meno */
	CORRECTION_COMMAND = "_fOut",
	/** Tempo per cui deve rimanere attiva la correzione */
	CORRECTION_TIMER_PERSISTENCE = "_T_switch",
	/** Correzione attivata 1 o meno 0 */
	CORRECTION_ENABLED = "_Enabled",
}

export enum PROBE_TYPE {
	PH = "PH",
	EC = "EC",
	TEMP = "TEMP",
}

export interface Probe {
	name: string
	type: PROBE_TYPE
	mA: number | string
	mAAlias: string
	min: number | string
	minAlias: string
	max: number | string
	maxAlias: string
	value: number | string
	valueAlias: string
	enabledAlias: string
}

export interface Alarm {
	name: string

	enabledAlias: string
	mode: number
	measure: string
	set:string

	s1Alias: string
	d1: string
	t1: string
	t1pAlias: string
	on1: boolean

	s2Alias: string
	d2: string
	t2: string
	t2pAlias: string
	on2: boolean
}
